import { render, staticRenderFns } from "./roomList-new.vue?vue&type=template&id=173a059e&scoped=true"
import script from "./roomList-new.vue?vue&type=script&lang=js"
export * from "./roomList-new.vue?vue&type=script&lang=js"
import style0 from "./roomList-new.vue?vue&type=style&index=0&id=173a059e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173a059e",
  null
  
)

export default component.exports